var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00416 6.99999C6.86095 6.99988 6.72352 6.94718 6.62218 6.8536L0.172011 0.864277C0.0647496 0.771918 0.00261366 0.643353 8.09074e-05 0.507883C-0.0024528 0.372522 0.0546153 0.241952 0.158257 0.146243C0.26202 0.0504306 0.403424 -0.00226403 0.55003 7.46531e-05C0.696744 0.00252563 0.835977 0.0597908 0.935996 0.158831L7.04023 5.78879L13.1806 0.118903C13.322 0.0402487 13.4948 0.0255434 13.6493 0.0791307C13.804 0.132718 13.9236 0.248694 13.9741 0.393855C14.0246 0.53902 14.0005 0.697657 13.9085 0.824345L7.38607 6.84704V6.84692C7.28605 6.94307 7.14851 6.99811 7.00409 7L7.00416 6.99999Z",
    fill: "#363636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.1fea9285d79e5100a32c574075ce374d.svg";
export { ForwardRef as ReactComponent };